<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        large
        depressed
        rounded
        class="rounded-card white--text"
        color="analogoA"
        :disabled="botaoDesabilitado"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>note_alt</v-icon>
        Anamnese
      </v-btn>
    </template>
    <v-card color="grey lighten-3">
      <v-toolbar dark color="analogoA">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Anamnese</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="orange" :disabled="load" dark depressed @click="cadastrarAnamnese()">
            {{ isAnamnese ? 'Alterar' : 'Salvar' }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form v-model="form" ref="form">
        <v-alert
          v-show="(!cadastroSucesso && !isAnamnese)"
          dense
          type="warning"
          class="pa-2 ma-2"
          color="#FA9B6B"
          prominent
          border="left">
          Atenção! Preencha a anamnese e clique em salvar. Você poderá alterar o texto depois, se necessário.
        </v-alert>
        <v-alert
          v-show="isAnamnese"
          dense
          type="info"
          class="pa-2 ma-2"
          color="#79B9FA"
          prominent
          border="left">
          Anamnese encontrada. Você pode alterar o texto e salvar novamente.
        </v-alert>
        <v-alert
          v-if="cadastroSucesso"
          dense
          type="success"
          class="pa-2 ma-2"
          prominent
          color="#32cd32"
          border="left">
          Anamnese cadastrada com sucesso!
        </v-alert>

        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="anamnese.descricao"
                :rules="[v => !!v || 'Campo obrigatório!']"
                class="d-none"
              />
              <editor
                :paciente="ficha"
                :conteudo="anamnese.descricao"
                :modoSimples="true"
                :mostrarModelos="true"
                :isUltimoProntuario="true"
                @conteudo="atualizarConteudo"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import medicoService from '../../services/medico.service'
import editor from '../editorDeTexto/editor.vue'
export default {
  components: { editor },
  props: {
    ficha: Object
  },
  computed: {
    user () {
      return this.$store.getters.usuario
    },
    botaoDesabilitado () {
      // return !!(this.user && this.user.tecnico)
      return false
    }
  },
  data () {
    return {
      form: '',
      dialog: false,
      isAnamnese: false,
      anamnese: {
        id: '',
        descricao: ''
      },
      load: false,
      cadastroSucesso: false
    }
  },
  methods: {
    atualizarConteudo (val) {
      this.anamnese.descricao = val
    },
    buscarAnamnese (idExamesos) {
      if (!idExamesos) {
        return
      }
      medicoService.medico.buscarAnamneseTextPorIdExamesos(idExamesos).then(r => {
        if (r.status == 200 && r.data) {
          const anamneseData = Array.isArray(r.data) ? r.data[0] : r.data
          if (!anamneseData) {
            return
          }
          this.isAnamnese = true
          this.anamnese = {
            ...this.anamnese,
            ...anamneseData,
            descricao: anamneseData.descricao || ''
          }
        }
      })
    },
    montarPayloadAnamnese () {
      const payload = {
        idMedico: this.ficha.idMedico,
        idPaciente: this.ficha.idPaciente,
        descricao: this.anamnese.descricao
      }
      if (this.ficha.idExame) {
        payload.idExame = this.ficha.idExame
      }
      if (this.ficha.idExamesos) {
        payload.idExamesos = this.ficha.idExamesos
      }
      if (this.ficha.idOrdemServico) {
        payload.idOrdemServico = this.ficha.idOrdemServico
      }
      if (this.user && this.user.id) {
        payload.idTecnico = this.user.id
      } else if (this.ficha.idTecnico) {
        payload.idTecnico = this.ficha.idTecnico
      }
      return payload
    },
    cadastrarAnamnese () {
      if (this.$refs.form.validate()) {
        this.load = true
        const payload = this.montarPayloadAnamnese()
        const request = (this.isAnamnese && this.anamnese.id)
          ? medicoService.medico.editarAnamneseText({
            id: this.anamnese.id,
            ...payload
          })
          : medicoService.medico.cadastrarAnamneseText(payload)

        request.then(r => {
          if (r.status === 200) {
            this.cadastroSucesso = true
          }
        }).finally(() => {
          setTimeout(() => {
            this.dialog = false
            this.cadastroSucesso = false
            this.load = false
            this.isAnamnese = true
          }, 2000)
        })
      }
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        this.isAnamnese = false
        this.buscarAnamnese(this.ficha.idExamesos)
      }
    }
  }
}
</script>
